import Grid from '@mui/material/Grid';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import { useTranslation } from 'react-i18next';
import { useAudienceInsights } from '../../context/audienceInsights';
import { ConnectedTv, Desktop, Display, IpAddress, MobileApp, MobileWeb, Video } from '../InsightItem/Icons';
import { InsightItem } from '../InsightItem/InsightItem';
export function MonthlyRequestEstimates() {
  const { t } = useTranslation();

  const { statistics } = useAudienceInsights();

  return (
    <FormSection divider title={t('Monthly Request Estimates')}>
      <Grid container rowSpacing={8}>
        <Grid size={3}>
          <InsightItem
            title={t('Display')}
            icon={<Display />}
            percentage={statistics.totalRequestDisplayPercent}
            value={statistics.totalRequestDisplay}
            dataTestId="insight-request-display"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('Video')}
            icon={<Video />}
            percentage={statistics.totalRequestVideoPercent}
            value={statistics.totalRequestVideo}
            dataTestId="insight-request-video"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('Mobile App')}
            icon={<MobileApp />}
            percentage={statistics.totalRequestMobileAppPercent}
            value={statistics.totalRequestMobileApp}
            dataTestId="insight-request-mobile-app"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('Mobile Web')}
            icon={<MobileWeb />}
            percentage={statistics.totalRequestMobileWebPercent}
            value={statistics.totalRequestMobileWeb}
            dataTestId="insight-request-mobile-web"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('Desktop')}
            icon={<Desktop />}
            percentage={statistics.totalRequestDesktopPercent}
            value={statistics.totalRequestDesktop}
            dataTestId="insight-request-desktop"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('CTV')}
            icon={<ConnectedTv />}
            percentage={statistics.totalRequestCTVPercent}
            value={statistics.totalRequestCTV}
            dataTestId="insight-request-ctv"
          />
        </Grid>

        <Grid size={3}>
          <InsightItem
            title={t('IP Address')}
            icon={<IpAddress />}
            percentage={statistics.totalRequestIPPercent}
            value={statistics.totalRequestIP}
            dataTestId="insight-request-ip-address"
          />
        </Grid>
      </Grid>
    </FormSection>
  );
}
